import React, { createContext, useContext, useState } from 'react'
import { formatAmount } from '../utils/currency'

const CurrencyContext = createContext({ currency: 'INR', setCurrency: () => {}, fmt: n => '₹' + n })

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(
    () => localStorage.getItem('dc_currency') || 'INR'
  )

  function setCurrency(c) {
    setCurrencyState(c)
    localStorage.setItem('dc_currency', c)
  }

  const fmt = n => formatAmount(n, currency)

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, fmt }}>
      {children}
    </CurrencyContext.Provider>
  )
}

export function useCurrency() {
  return useContext(CurrencyContext)
}
